import React from "react";
import styles from "./index.module.scss";
import { ReceiptRow } from "../ReceiptRow";
import { Discount } from "@/types/discount";
import { useAppSelector } from "@/hooks/useAppSelector";
import { selectCartProducts, selectCartDiscounts } from "@/store/cart/selectors";
import VoucherInfo from "./VoucherInfo";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { removeDiscount } from "@/store/cart/thunk";
import useCashRegisterStore from "@/stores/cash-register";
import { getDiscountId } from "@/helpers/discount";

const Discounts: React.FC = () => {
  const dispatch = useAppDispatch();
  const products = useAppSelector(selectCartProducts);
  const discounts = useAppSelector(selectCartDiscounts);
  const { current } = useCashRegisterStore();
  if (!products.length && discounts.length === 0) return null;

  const getRemover = (discount: Discount) => {
    if (!discount.meta) return;
    return () => {
      const discountId = getDiscountId(discount);
      if (!discountId) return;
      dispatch(removeDiscount(discountId, discount.type));
    };
  };

  return (
    <div className={styles.container}>
      {discounts.length === 0 && current?.shop.property.vouchersEnabled && <VoucherInfo />}
      <div className={styles.vouchers}>
        {discounts.map((discount, index) => (
          <ReceiptRow
            key={`${getDiscountId(discount)}-${index}`}
            translations={discount.translations}
            pricePerUnit={"priceCents" in discount ? discount.priceCents : undefined}
            minimumQuantity={"quantity" in discount ? discount.quantity : 1}
            quantity={"quantity" in discount ? discount.quantity : 1}
            maximumQuantity={"quantity" in discount ? discount.quantity : 1}
            onDecrement={getRemover(discount)}
            onRemoveAll={getRemover(discount)}
            isDiscount
          />
        ))}
      </div>
    </div>
  );
};

export default Discounts;
